module.exports = __webpack_public_path__ + "static/media/avatar-01.a1a36774.svg";